var app_radio_ranker_table = $('#app-radio-ranker-report-table');

if (app_radio_ranker_table.length) {
    var saved_table_data = [];
    var unsaved_table_data = [];

    var saved_table;
    var unsaved_table;

    $(document).ready(function(){
        radioReportTables();
    });

    var radioReportTables = function(){
        saved_table_data = [];
        unsaved_table_data = [];

        $.ajax({
            type: "GET",
            url: (location.href.indexOf('ratings/eastlan-radio/ranker/station') < 0) ? '/ratings/radio/ranker/station/list/saved' : '/ratings/eastlan-radio/ranker/station/list/saved',
            dataType: 'json',
            success: function (data) {
                $.each(data['data'], function(index, value){

                    push = {
                        'order': value['order'],
                        'name': value['name'],
                        'slug': value['slug'],
                        'created_at': value['human_created_at']
                    };
                    saved_table_data.push(push);
                });

                if (saved_table instanceof $.fn.dataTable.Api) {
                    var table = $('#app-radio-ranker-report-saved').DataTable();

                    table.clear();
                    table.rows.add(saved_table_data);
                    table.draw();
                } else {
                    saved_table = $('#app-radio-ranker-report-saved').DataTable({
                        data: saved_table_data,

                        columns: [
                            {data:'order'},
                            {data: 'name'},
                            {data: 'created_at'},
                            {data: 'slug'}
                        ],

                        order: [0, 'asc'],
                        destroy: true,
                        pageLength: user_entries,
                        "columnDefs": [
                            {
                                "targets": 0,
                                "visible": false,
                                "searchable": false,
                            },
                            {
                            "targets": 3,
                            "orderable": false,
                            "createdCell": function (td, cellData, rowData, row, col) {
                                var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                                '<a href="/ratings/radio/ranker/station/view/' +
                                cellData +
                                '" role="button" class="btn btn-info btn-sm">' +
                                '<i class="fa fa-eye"></i> View' +
                                '</a>' +
                                '</div>' +
                                    '<a href="/ratings/radio/ranker/station/edit/' + cellData +' "  class="btn btn-success btn-sm btn-disabled edit-report " role="button">' +
                                    '<i class="fa fa-pencil"></i> Edit' +
                                    '</a>' +
                                    '<a href="javascript:void(0)" class="btn btn-danger btn-sm btn-disabled delete-report" data-slug="' + cellData + '" role="button">' +
                                    '<i class="fa fa-trash-o"></i> Delete' +
                                    '</a></div>';
                                $(td).html(html);
                            }
                        }],
                        "drawCallback": function( settings ) {
                            $('.delete-report').unbind('click').bind('click', function(){
                                deleteRadioReport($(this).attr('data-slug'));
                            });
                        }
                    });
                }

            }

        });

        $.ajax({
            type: "GET",
            url: (location.href.indexOf('ratings/eastlan-radio/ranker/station') < 0) ? '/ratings/radio/ranker/station/list/temp' : '/ratings/eastlan-radio/ranker/station/list/temp',
            dataType: 'json',
            success: function (data) {
                $.each(data['data'], function(index, value){
                    push = {
                        'order':value['order'],
                       'name': value['name'],
                        'slug': value['slug'],
                        'created_at': value['human_created_at']
                    };

                    unsaved_table_data.push(push);
                });

                if (unsaved_table instanceof $.fn.dataTable.Api) {
                    var table = $('#app-radio-ranker-report-temp').DataTable();

                    table.clear();
                    table.rows.add(unsaved_table_data);
                    table.draw();
                } else {
                    unsaved_table = $('#app-radio-ranker-report-temp').DataTable({
                        data: unsaved_table_data,
                        columns: [
                            {data: 'order'},
                            {data: 'name'},
                            {data: 'created_at'},
                            {data: 'slug'}
                        ],
                        order: [0, 'asc'],
                        destroy: true,
                        pageLength: user_entries,
                        "columnDefs": [
                            {
                                "targets": 0,
                                "visible": false,
                                "searchable": false,
                            },
                            {
                            "targets": 3,
                            "orderable": false,
                            "createdCell": function (td, cellData, rowData, row, col) {
                                var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                                    '<a href="/ratings/radio/ranker/station/view/' +
                                    cellData +
                                    '" role="button" class="btn btn-info btn-sm">' +
                                    '<i class="fa fa-eye"></i> View' +
                                    '</a>' +
                                    '</div>' +
                                    '<a href="javascript:void(0)" class="btn btn-danger btn-sm btn-disabled delete-report" data-slug="' + cellData + '" role="button">' +
                                    '<i class="fa fa-trash-o"></i> Delete' +
                                    '</a></div>';
                                $(td).html(html);
                            }
                        }],
                        "drawCallback": function( settings ) {
                            $('.delete-report').unbind('click').bind('click', function(){
                                deleteRadioReport($(this).attr('data-slug'));
                            });
                        }
                    });
                }
            }
        });


    };




    var deleteRadioReport = function(slug) {
        var urlVar = '/ratings/radio/ranker/station/delete/' + slug;
        swal({
                title: "Warning",
                text: "Are you sure you want to delete?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_loader();
                    $.ajax({
                        url: urlVar,
                        success: function (response) {
                            global_notification('success', 'Report deleted.');
                            radioReportTables();
                            hide_loader();
                        },
                        error: function (xhr) {
                            ajax_error();
                            debug(xhr.responseText);
                            radioReportTables();
                        }
                    });
                }
            });
    }
};
